import styled from "@emotion/styled";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import {
  SectionContent,
  SectionHeading,
  SectionSmallHeading,
  SectionText,
} from "../shared/Section";
import splitText from "../shared/splitText";

const Name = styled.span`
  font-size: 1.2rem;
  font-weight: 700;
  color: ${(props) => props.theme.accentColor};
  margin-bottom: 0.5rem;
  @media (${(props) => props.theme.breakpoint}) {
    font-size: 1rem;
    margin-top: auto;
  }
`;

const Content = styled.div`
  margin-top: auto;
`;

const About = ({ visible }) => {
  const { t } = useTranslation();
  const heading = useRef();

  useEffect(() => {
    if (heading) {
      splitText(heading.current);
    }
  }, [heading]);

  return (
    <SectionContent
      height={"60vh"}
      className={visible ? "section-content active" : "section-content"}
    >
      <Name>Dorian Guilmain</Name>
      <SectionHeading as={"h1"} ref={heading}>
        <Trans i18nKey={"About.title"}>
          Front-end Developer with <strong>CSS</strong> powers and a{" "}
          <strong>creative</strong> mind
        </Trans>
      </SectionHeading>
      <Content>
        <SectionSmallHeading>{t("About.subheading")}</SectionSmallHeading>
        <SectionText maxWidth="300px">
          <Trans i18nKey={"About.content"}>
            For more than 4 years, I have enjoyed building creative and visual
            experiences using code. The crazier it is, the more interested I am.
            I also share my knowledge through{" "}
            <a
              href="https://blog.dorianguilmain.com"
              target="_blank"
              rel="noreferrer"
            >
              a blog
            </a>
            .
          </Trans>
        </SectionText>
      </Content>
    </SectionContent>
  );
};

export default About;
